/**
 * @generated SignedSource<<5a7ea473532e4b24e9866abff19ca227>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ListItemTypeInput = {
  child: string;
  code?: string | null | undefined;
  description?: string | null | undefined;
  id?: string | null | undefined;
  link_id?: string | null | undefined;
  name: string;
  parent?: string | null | undefined;
  type: string;
};
export type CreateListItemMutation$variables = {
  connections: ReadonlyArray<string>;
  input: ListItemTypeInput;
};
export type CreateListItemMutation$data = {
  readonly createListItem: {
    readonly cursor: string;
    readonly node: {
      readonly id: string | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"ItemFragment">;
    } | null | undefined;
  } | null | undefined;
};
export type CreateListItemMutation = {
  response: CreateListItemMutation$data;
  variables: CreateListItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateListItemMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "ListItemEdge",
        "kind": "LinkedField",
        "name": "createListItem",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ListItem",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ItemFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateListItemMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "ListItemEdge",
        "kind": "LinkedField",
        "name": "createListItem",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ListItem",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "child",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "parent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "link_id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": null,
        "handle": "appendEdge",
        "key": "",
        "kind": "LinkedHandle",
        "name": "createListItem",
        "handleArgs": [
          {
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "c46a5c857bcef30ddd63d47385614f8d",
    "id": null,
    "metadata": {},
    "name": "CreateListItemMutation",
    "operationKind": "mutation",
    "text": "mutation CreateListItemMutation(\n  $input: ListItemTypeInput!\n) {\n  createListItem(input: $input) {\n    cursor\n    node {\n      id\n      ...ItemFragment\n    }\n  }\n}\n\nfragment ItemFragment on ListItem {\n  id\n  name\n  code\n  description\n  child\n  type\n  parent\n  link_id\n}\n"
  }
};
})();

(node as any).hash = "1844423ab30534395e96aa9debd40574";

export default node;
